import script from "./QuestionSourceSplash.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionSourceSplash.vue?vue&type=script&setup=true&lang=js"

import "./QuestionSourceSplash.vue?vue&type=style&index=0&id=8a0d341a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a0d341a"]])

export default __exports__